// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      id: string,
    },
  },
};

const mutation = graphql`
  mutation DeleteMachineTypeMutation($input: DeleteMachineTypeInput!) {
    deleteMachineType(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: (options: MutationOptions) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_DELETE',
          parentID: ROOT_ID,
          connectionKeys: [{ key: 'MachineTypes_machineTypes' }],
          pathToConnection: [ROOT_ID, 'machineTypes'],
          deletedIDFieldName: 'deletedId',
        },
      ],
    });
  },
};
